import React from 'react';
import { Logo } from './Logo';
import { ChevronDown, Calendar, User } from 'lucide-react';
import { dashboardData } from './data';
export function Header() {
  return <header className="bg-white border-b border-slate-200 px-6 py-4 flex flex-col md:flex-row items-center justify-between gap-4 sticky top-0 z-50 shadow-sm" data-id="element-111">
      <div className="flex items-center gap-4" data-id="element-112">
        <Logo data-id="element-113" />
        <div className="hidden md:block h-10 w-px bg-slate-200" data-id="element-114"></div>
        <div data-id="element-115">
          <h1 className="text-2xl md:text-3xl font-black text-[#0a1e5e] tracking-tight uppercase" data-id="element-116">
            Team Lead Scorecard
          </h1>
          <p className="text-blue-600 font-semibold text-sm tracking-wide uppercase mt-0.5" data-id="element-117">
            Lead. Develop. Empower. Win Together.
          </p>
        </div>
      </div>

      <div className="flex items-center gap-4 w-full md:w-auto" data-id="element-118">
        <div className="flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-lg px-4 py-2.5 flex-1 md:flex-none cursor-pointer hover:bg-slate-100 transition-colors h-[52px]" data-id="element-119">
          <div className="w-8 h-8 rounded-full bg-[#0a1e5e] text-white flex items-center justify-center overflow-hidden" data-id="element-120">
            {dashboardData.user.avatarUrl ? <img src={dashboardData.user.avatarUrl} alt="User" className="w-full h-full object-cover" data-id="element-121" /> : <User size={16} data-id="element-122" />}
          </div>
          <div className="flex flex-col" data-id="element-123">
            <span className="text-xs font-bold text-slate-500 uppercase leading-none" data-id="element-124">
              {dashboardData.user.role}
            </span>
            <span className="text-sm font-bold text-[#0a1e5e] leading-tight mt-1" data-id="element-125">
              {dashboardData.user.name}
            </span>
          </div>
          <ChevronDown size={16} className="text-slate-400 ml-2" data-id="element-126" />
        </div>

        <div className="flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-lg px-4 py-2.5 flex-1 md:flex-none cursor-pointer hover:bg-slate-100 transition-colors h-[52px]" data-id="element-127">
          <Calendar size={18} className="text-[#0a1e5e]" data-id="element-128" />
          <div className="flex flex-col" data-id="element-129">
            <span className="text-xs font-bold text-slate-500 uppercase leading-none" data-id="element-130">
              Month
            </span>
            <span className="text-sm font-bold text-[#0a1e5e] leading-tight mt-1" data-id="element-131">
              {dashboardData.user.currentMonth}
            </span>
          </div>
          <ChevronDown size={16} className="text-slate-400 ml-2" data-id="element-132" />
        </div>
      </div>
    </header>;
}